import { Component } from '@angular/core';

@Component({
  selector: 'app-layout',
  template: '<router-outlet><spinner></spinner></router-outlet>'
})
export class AuthLayoutComponent {}



// WEBPACK FOOTER //
// D:/Projects/Yahoo/Server API/ServerAPI/AdminAngular/src/app/layouts/auth/auth-layout.component.ts